module.exports = __webpack_public_path__ + "img/especiais.0b21ff11.svg";